module.exports = require('./dist/rambda.js')